import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    Type,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ElementService {
    animateName: string;
    constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
    /**
     * Components to htlmelement
     * @param componentRef ComponentRef<ModalComponent>
     * @returns HTMLElement
     */
    componentToHTLMElement<T>(componentRef: ComponentRef<T>): HTMLElement {
        return (componentRef.hostView as EmbeddedViewRef<any>)
            .rootNodes[0] as HTMLElement;
    }
    /**
     * Appends dialog component to body
     * @template T
     * @param map WeakMap<object, any>
     * @param injector any
     * @param appRef ApplicationRef
     * @param componentDefault Type<T>
     * @param [classList] string[]
     * @returns ComponentRef<T>
     */
    appendDialogComponentToBody<T>(
        appRef: ApplicationRef,
        injector: any,
        componentDefault: Type<T>,
        classList?: string[]
    ): ComponentRef<T> {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            componentDefault
        );
        const componentRef = componentFactory.create(injector);

        appRef.attachView(componentRef.hostView);

        const domElem = this.componentToHTLMElement(componentRef);

        document.body.appendChild(domElem);

        for (let item of classList) {
            document.body.classList.add(item);
        }

        return componentRef;
    }
    /**
     * Removes modal component from body
     * @template T 
     * @param appRef ApplicationRef
     * @param componentsReferences ComponentRef<T>[]
     * @param key number
     */
    removeModalComponentFromBody<T>(
        appRef: ApplicationRef,
        componentsReferences: ComponentRef<T>[],
        key: number,
        className: string,
        classRemoveName: string
    ) {
        let componentRef;

        for (const [index, item] of componentsReferences?.entries()) {
            if (item.instance['uniqueKey'] === key) {
                componentRef = item;
                componentsReferences?.splice(index, 1);
            }
        }

        if (componentRef) {
            if (componentsReferences.length === 0) {
                document.body.classList.remove(className);
            }

            const domElem: Element = (componentRef.hostView as EmbeddedViewRef<any>)
                .rootNodes[0];
            const dialog: any = domElem.firstChild.firstChild;
            
            dialog.classList.add(classRemoveName);

            document.body.addEventListener('animationend', (event) => {
                // console.warn(event);
                this.removeElement(appRef, event, componentRef);
            });
            document.body.addEventListener('webkitAnimationEnd', (event) => {
                // console.warn(event);
                this.removeElement(appRef, event, componentRef);
            });
            // appRef.detachView(componentRef.hostView);
            // componentRef.destroy();
        }
    }
    /**
     * Removes element
     * @template T
     * @param event
     * @param componentRef ComponentRef<T>
     */
    removeElement<T>(
        appRef: ApplicationRef,
        event,
        componentRef: ComponentRef<T>
    ): void {
        if (event.animationName === this.animateName) {
            appRef.detachView(componentRef.hostView);
            componentRef.destroy();

            const modalViewRef = (componentRef.hostView as EmbeddedViewRef<any>)
                .rootNodes[0] as HTMLElement;
            if (modalViewRef) {
                modalViewRef.remove();
            }
        }
    }
}
